import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../../components/Card";
import SiteDataTable from "../../datatables/SiteDataTable";
import CustomerJobDataTable from "../../datatables/CustomerJobDataTable";
import FileGallery from "../../components/file-gallery";
import InvoiceDataTable from '../../datatables/InvoiceDataTable';

const TABS = {
    sites: {
        name:   'Sites',
        value:  'sites'
    },
    jobs: {
        name:   'Jobs',
        value:  'jobs'
    },
    documents: {
        name:   'Documents',
        value:  'documents'
    },
    invoices: {
        name:   'Invoices',
        value:  'invoices'
    }
}

const CustomerShowPage = ({ customerId, preSelectedTab = TABS.sites.value }) => {
    const [currentTab, setCurrentTab]   = useState(preSelectedTab);

    const renderTabs = () => {
        return (
            <div className={"tab-container mb-4"}>
                {Object.values(TABS).map((tab) => {
                    let active = currentTab === tab.value;

                    return (
                        <div
                            key={tab.value}
                            className={active ? "tab active" : "tab"}
                            onClick={() => setCurrentTab(tab.value)}
                        >
                            {tab.name}
                        </div>
                    );
                })}
            </div>
        );
    }

    const renderTabContent = () => {
        switch (currentTab) {
            case TABS.sites.value:
                return can('viewAny', 'site') ? (
                    <SiteDataTable customerId={customerId} />
                ) : null;
            case TABS.jobs.value:
                return can('viewAny', 'job') ? (
                    <CustomerJobDataTable customerId={customerId}/>
                ) : null;
            case TABS.documents.value:
                return (
                    <FileGallery
                        getRoute={route('web-api.customer.document.index', {customer: customerId})}
                        uploadRoute={route('web-api.customer.document.store', {customer: customerId})}
                        deleteRoute={route('web-api.customer.document.destroy', {customer: customerId})}
                        noPadding={true}
                        parentId={'customer-show-page'}
                    />
                );
            case TABS.invoices.value:
                return <InvoiceDataTable
                    customerId={customerId}
                />;
            default:
                console.log(`Unimplemented tab: ${currentTab}`);
                return null;
        }
    }

    return (
        <React.Fragment>
            <Card classes={"mh-100 border-0"}>
                {renderTabs()}
                {renderTabContent()}
            </Card>
        </React.Fragment>
    );
}

export default CustomerShowPage;

const target = document.getElementById('customer-show-page');
if (target) {
    const {
        customerId = null,
        tab = TABS.sites.value
    } = target.dataset;

    ReactDOM.render(<CustomerShowPage customerId={customerId} preSelectedTab={tab} />, target);
}
